import React, { useState, useEffect } from "react";
import _ from "lodash";
import Logo from "~/images/Stemline.png";
import OrserduDesignationForm from "./OrserduDesignationForm";

const StemlineDesignations = (props) => {
  const manufacturer_name = "stemline";
  const vanity_manufacturer_name = "Stemline Therapeutics";

  const [retailHasSelectedSpecialtyPharmacy, setRetailHasSelectedSpecialtyPharmacy] =
    useState(false);
  const [retailSelectedSpecialtyPharmacy, setRetailSelectedSpecialtyPharmacy] = useState();
  const [manufacturerFormDetails, setManufacturerFormDetails] = useState({
    stemline: {},
  });

  useEffect(() => {
    props.setCompletedDesignations(isComplete());
  }, [manufacturerFormDetails]);

  const isComplete = () => {
    const openForms = _.flatMap(manufacturerFormDetails, (manufacturer) =>
      _.filter(manufacturer, (form) => form.open)
    );
    return openForms.length ? _.every(openForms, ["completed", true]) : true;
  };

  const specialtyForms = [
    { component: OrserduDesignationForm, key: "orserdu", manufacturer: manufacturer_name },
  ];
  const renderSpecialtyForm = ({ component: Component, key, manufacturer }) => (
    <Component
      key={key}
      entities={props.entities}
      specialtyKeyName={key}
      manufacturerFormDetails={manufacturerFormDetails}
      setManufacturerFormDetails={setManufacturerFormDetails}
      manufacturer={manufacturer}
      manufacturerName={vanity_manufacturer_name}
      retailSelectedSpecialtyPharmacy={retailSelectedSpecialtyPharmacy}
      retailHasSelectedSpecialtyPharmacy={retailHasSelectedSpecialtyPharmacy}
      isBlocked={_.some(props.entities, (e) => e.blocked.includes(key))}
    />
  );

  return (
    <div>
      <div className="designation_form__section__header">
        <div className="designation_form__section__header__logo">
          <img src={Logo} alt="Stemline Logo" />
        </div>
        <div className="designation_form__section__header__title">{vanity_manufacturer_name}</div>
      </div>
      {specialtyForms.map(renderSpecialtyForm)}
    </div>
  );
};

export default StemlineDesignations;
